(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slideshow-2"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  var slides = document.querySelectorAll('.slideshow-slide-bro');
  var carousel = document.querySelector('.slideshow-carousel-bro');
  var paginationContainer = document.querySelector('.slideshow-pagination-bro');
  var totalSlides = slides.length;
  var currentIndex = 0;
  var autoSlide;

  // Create pagination dots
  slides.forEach(function (_, index) {
    var dot = document.createElement('div');
    dot.classList.add('slideshow-dot-bro');
    if (index === 0) dot.classList.add('active');
    dot.addEventListener('click', function () {
      clearInterval(autoSlide);
      goToSlide(index);
      restartAutoSlide();
    });
    paginationContainer.appendChild(dot);
  });

  var dots = document.querySelectorAll('.slideshow-dot-bro');

  function goToSlide(index) {
    currentIndex = (index + totalSlides) % totalSlides;
    var offset = -currentIndex * 100;
    carousel.style.transform = 'translateX(' + offset + '%)';
    updateDots();
  }

  function updateDots() {
    dots.forEach(function (dot, idx) {
      dot.classList.toggle('active', idx === currentIndex);
    });
  }

  function showNextSlide() {
    goToSlide(currentIndex + 1);
  }

  function showPrevSlide() {
    goToSlide(currentIndex - 1);
  }

  function startAutoSlide() {
    autoSlide = setInterval(showNextSlide, 5000);
  }

  function restartAutoSlide() {
    clearInterval(autoSlide);
    startAutoSlide();
  }

  document.querySelector('.arrow-next').addEventListener('click', function () {
    showNextSlide();
    restartAutoSlide();
  });

  document.querySelector('.arrow-prev').addEventListener('click', function () {
    showPrevSlide();
    restartAutoSlide();
  });

  startAutoSlide();
});

  } catch(e) { console.error(e); }
})();
})();
